module.exports = __webpack_public_path__ + "static/media/ticon1.6c53978d.webp";